import { gql } from '@/__generated__/storefront';

export const searchPatternsBySKUsQuery = gql(`
  query SearchPatternsBySKUs($searchQuery: String!, $country: CountryCode!) @inContext(country: $country) {
    search(query: $searchQuery, types: [PRODUCT], first: 50) {
      nodes {
        ... on Product {
          id
          title
          handle
          productType
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          compareAtPriceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          metafields(identifiers: [
            {namespace: "hobbii", key: "sku"},
            {namespace: "hobbii", key: "designer"},
            {namespace: "hobbii", key: "difficulty"},
            {namespace: "hobbii", key: "pattern_kind"},
            {namespace: "hobbii", key: "entity_type"}
          ]) {
            key
            value
          }
          featuredImage {
            altText
            height
            url
            width
          }
          variants(first: 5) {
            nodes {
              id
              title
              sku
              quantityAvailable
              price {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
                currencyCode
              }
              image {
                url
                altText
              }
            }
          }
        }
      }
    }
  }
`);

export const patternsCollectionQuery = gql(`
  query PatternsCollection($country: CountryCode!) @inContext(country: $country) {
    collectionByHandle(handle: "patterns-for-recommendations") {
      id
      title
      products(first: 250) {
        nodes {
          id
          title
          handle
          productType
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          compareAtPriceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          metafields(identifiers: [
            {namespace: "hobbii", key: "sku"},
            {namespace: "hobbii", key: "designer"},
            {namespace: "hobbii", key: "difficulty"},
            {namespace: "hobbii", key: "pattern_kind"},
            {namespace: "hobbii", key: "entity_type"}
          ]) {
            key
            value
          }
          featuredImage {
            altText
            height
            url
            width
          }
          variants(first: 5) {
            nodes {
              id
              title
              quantityAvailable
              price {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`);
